import React from 'react';

const variantClasses = {
  line: {
    shell: 'hidden items-center gap-6 md:flex',
    active: 'text-[var(--cc-accent)]',
    idle: 'cc-text-subtle hover:text-[#a9bdd6]',
    disabled: 'cursor-not-allowed text-[#4f647d]',
  },
  pills: {
    shell: 'inline-flex items-center gap-1 rounded-xl bg-[#0d1727]/90 p-1',
    active: 'bg-[var(--cc-accent-soft)] text-[var(--cc-accent)]',
    idle: 'cc-text-subtle hover:bg-[#152238] hover:text-[#c9d7e7]',
    disabled: 'cursor-not-allowed text-[#4f647d]',
  },
};

export default function TopTabs({
  tabs = [],
  active = '',
  onChange,
  variant = 'line',
  className = '',
}) {
  const classes = variantClasses[variant] || variantClasses.line;
  return (
    <div className={`${classes.shell} ${className}`}>
      {tabs.map((tab) => {
        const isActive = tab.value === active;
        const disabled = Boolean(tab.disabled);
        return (
          <button
            key={tab.value}
            type="button"
            onClick={() => !disabled && onChange?.(tab.value)}
            disabled={disabled}
            title={tab.title || ''}
            className={`text-[10px] font-semibold uppercase tracking-[0.18em] transition ${
              isActive
                ? classes.active
                : disabled
                  ? classes.disabled
                  : classes.idle
            }`}
          >
            {tab.label}{tab.count != null ? ` (${tab.count})` : ''}
          </button>
        );
      })}
    </div>
  );
}
